import { SettingsScreen } from '@app/settings/components/SettingsScreen';

export const AdminSettingsPage = () => {
  return <SettingsScreen />;
};
